import React from 'react';

// Styles & Assets
import styles from './SelectableButton.module.css';

const SelectableButton: React.FC<{
    active: boolean,
    disabled?: boolean,
    label: string,
    handleClick: () => void
    classButton?: string
    classActive?: string
}> = ({ active, disabled, label, handleClick, classButton, classActive }) => {

    const classes = `${styles.button} ${classButton || ''} ${active ? `${styles.active} ${classActive || ''}` : ''} ${disabled ? styles.NoClick : ''}`;

    return (
        <button
            disabled={disabled}
            className={classes}
            onClick={handleClick}
        >
            {label}
        </button>
    );
};

export default SelectableButton;